export enum EquipmentType {
  BatteryLimit = 0,
  Stream = 1,
  EnergyStream = 2,
  Vessel = 3,
  StreamMixer = 4,
  StreamSplitter = 5,
  Pump = 6,
  Compressor = 7,
  Reactor = 8,
  Expander = 9,
  Spreadsheet = 10,
  ComponentSplitter = 11,
  HeatExchanger = 12,
  Set = 13,
  Valves = 14,
  Rotating = 15,
  Tanks = 16,
  Deaerator = 111,
  SteamDrum = 102,
  Burner = 110
}


export const EquipmentTagPerfix = {
  [EquipmentType.BatteryLimit]: 'BL',
  [EquipmentType.Stream]: 'SS',
  [EquipmentType.EnergyStream]: 'ES',
  [EquipmentType.Vessel]: 'V',
  [EquipmentType.Deaerator]: 'V',
  [EquipmentType.SteamDrum]: 'V',
  [EquipmentType.StreamMixer]: 'MT',
  [EquipmentType.StreamSplitter]: 'ST',
  [EquipmentType.Pump]: 'P',
  [EquipmentType.Compressor]: 'C',
  [EquipmentType.Reactor]: 'R',
  [EquipmentType.Burner]: 'R',
  [EquipmentType.Expander]: 'EX',
  [EquipmentType.Spreadsheet]: 'SP',
  [EquipmentType.ComponentSplitter]: 'CS',
  [EquipmentType.HeatExchanger]: 'HX',
  [EquipmentType.Set]: 'SET',
  [EquipmentType.Valves]: 'VAV',
}


export enum NozzleType {
  FlowNozzle = 0,
  EnergyFlowNozzle = 1,
  InstNozzle = 2,
  SetNozzle = 3,
  CustomFlowNozzle = 4,
}

export enum PropertyPackage {
  PengRobinson = 0,
}

export enum ReactionType {
  Conversion = 'conversion',
  Equilibrium = 'equilibrium'
}

export const reactionTypeText = {
  conversion: 'Conversion',
  equilibrium: 'Equilibrium'
}

export enum Flip {
  None = 0,
  X = 1,
  Y = 2
}

export enum NozzleDirection {
  Inlet = 0,
  Outlet = 1
}

export enum Origin {
  Start = 0,
  Center = 1,
  End = 2
}


export interface GraphAttributes {
  x:number
  y:	number
  angle:	number
  width:	number
  height:	number
}

export interface ManualVal {
  type: number
  val: number
}
export type ManualVar = ManualVal | number

export enum ChangeType {
  Change,
  Delete
}